import { Avatar } from "@octopusdeploy/design-system-components";
import type { ProcessTemplateResource, IconMetadataResource, IconSvgResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import ProcessTemplateIconEditLayout from "~/areas/platformHub/processTemplates/ProcessTemplateIconEditLayout";
import { getProcessTemplateIconUrl } from "~/areas/platformHub/processTemplates/ProcessTemplatesPage";
import IconEditor, { IconEditorDefaultColor } from "~/components/form/IconEditor/IconEditor";
import { Summary } from "~/components/form/Sections/index";
import { ExpandableFormSection, required } from "~/components/form/index";
import { DebounceText } from "~/primitiveComponents/form/Text/Text";
interface EditProcessTemplateSettingsTabProps {
    iconSvgResources: IconSvgResource[];
    iconMetadata: IconMetadataResource | undefined;
    processTemplate: ProcessTemplateResource;
    onChange: (processTemplate: ProcessTemplateResource) => void;
}
export function EditProcessTemplateSettingsTab({ iconSvgResources, iconMetadata, onChange, processTemplate }: EditProcessTemplateSettingsTabProps) {
    const setName = (value: string) => onChange({ ...processTemplate, Name: value });
    const setDescription = (value: string) => onChange({ ...processTemplate, Description: value });
    const setIconId = (value: string) => onChange({
        ...processTemplate,
        Icon: {
            Color: processTemplate.Icon?.Color ?? IconEditorDefaultColor,
            Id: value,
        },
    });
    const setIconColor = (value: string) => onChange({
        ...processTemplate,
        Icon: {
            Id: processTemplate.Icon?.Id ?? "",
            Color: value,
        },
    });
    return (<div>
            <ExpandableFormSection title="Name" errorKey="Name" summary={processTemplate.Name ? Summary.summary(processTemplate.Name) : Summary.placeholder("Please enter a name for your process template")} help="A short, memorable, unique name for this process template.">
                <DebounceText value={processTemplate.Name} onChange={setName} label="Process template name" validate={required("Please enter a name")}/>
            </ExpandableFormSection>
            <ExpandableFormSection title="Description" errorKey="Description" summary={processTemplate.Description ? Summary.summary(processTemplate.Description) : Summary.placeholder("No process template description provided")} help="Enter a description for this process template.">
                <DebounceText value={processTemplate.Description ?? ""} label="Process template description" onChange={setDescription}/>
            </ExpandableFormSection>
            <ExpandableFormSection errorKey="icon" title="Icon" summary={iconSummary(processTemplate)} help="Choose an icon.">
                {iconSvgResources && iconMetadata ? (<>
                        <ProcessTemplateIconEditLayout iconEditor={<IconEditor icons={iconSvgResources} iconMetadata={iconMetadata} selectedIconId={processTemplate.Icon?.Id ?? ""} selectedIconColor={processTemplate.Icon?.Color ?? IconEditorDefaultColor} onIconIdChange={setIconId} onIconColorChange={setIconColor}/>}/>
                    </>) : null}
            </ExpandableFormSection>
        </div>);
}
function iconSummary(processTemplate: ProcessTemplateResource) {
    return Summary.summary(<Avatar type="template" size="medium" src={getProcessTemplateIconUrl(processTemplate)} alt={`${processTemplate.Slug} icon`}/>);
}
